import { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "react-datepicker/dist/react-datepicker.css";
import {
  checkWalletBalanceAction,
  getCurrentPartnerStepInfoAction,
  getMyWalletBalanceAction,
  getPaymentMethodsAction,
  saveStepData,
} from "../../../Redux/AddOrEditPartner/AddOrEditPartnerActions";
import { useDispatch, useSelector } from "react-redux";
import { setStep3EmoneyFromWalletErrors } from "../../../Redux/AddOrEditPartner/AddOrEditPartnerSlice";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_blue.css";
import { format } from "date-fns";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import RowLoader from "../../../Components/UI/RowLoader";
import HeaderStep from "./HeaderStep";
import { getPaymentChannels } from "../../../apis";
import { PAYMENT_CHANNELSS } from "../../../constants/globals";

// Initial values for the form
const stepOneInitialData = {
  emoney_source: "",
  payment_method: "",
  payment_value: "",
  payment_date: "",
  payment_trans_number: "",
  document: null,
  payment_note: "",
};

const PartnerStepThree = () => {
  const location = useLocation();
  const { step1, step3, step4 } = useSelector(
    (state) => state?.AddOrEditPartner
  );
  const { lang } = useSelector((state) => state?.UI); //ar or en
  const navigate = useNavigate();
  const [requestSent, setRequestSent] = useState(false);
  const [paymentChannels, setPaymentChannels] = useState([]);
  const [currentPaymentChannels, setCurrentPaymentChannels] = useState(
    new URLSearchParams(location.search).get("currentPaymentChannel") || ""
  );
  const dispatch = useDispatch();
  const { stepInfo: Step1Info, isLoading } = step1;
  const { EmoneyValidation, paymentMethods, message } = step3;
  const { myWalletBalance, getWalletBalanceLoading } = step4;

  const StepOneSchema = Yup.object().shape({
    emoney_source: Yup.string().required("You must select payment way"),

    payment_method: Yup.string().when("emoney_source", {
      is: PAYMENT_CHANNELSS.PaymentVerification,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),
    payment_value: Yup.number().when("emoney_source", {
      is: PAYMENT_CHANNELSS.PaymentVerification,
      then: (schema) =>
        schema
          .required("Required")
          .positive("Must be a positive number")
          .test(
            "divisible-by-30",
            "The amount must be a multiple of 30",
            (value) => value % 30 === 0
          ),
      otherwise: (schema) => schema.nullable(),
    }),
    payment_date: Yup.date().when("emoney_source", {
      is: PAYMENT_CHANNELSS.PaymentVerification,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.nullable(),
    }),

    payment_trans_number: Yup.string().notRequired(),

    document: Yup.mixed().when("emoney_source", {
      is: PAYMENT_CHANNELSS.PaymentVerification,
      then: (schema) =>
        schema
          .required("Required")
          .test("fileType", "Invalid file format", function (value) {
            if (!value) return true; // Handle optional file input
            const allowedExtensions = ["pdf", "png", "jpg", "jpeg"];
            const fileExtension = value?.name?.split(".").pop().toLowerCase();
            return allowedExtensions.includes(fileExtension);
          })
          .test(
            "fileSize",
            "File size must be less than 5MB",
            function (value) {
              if (!value) return true; // Handle optional file input
              const maxSize = 5 * 1024 * 1024; // 5MB in bytes
              return value?.size <= maxSize;
            }
          ),
      otherwise: (schema) => schema.nullable(),
    }),
  });

  useEffect(() => {
    getPaymentChannels()
      .then((response) => {
        setPaymentChannels(response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    const params = new URLSearchParams();
    if (currentPaymentChannels) {
      params.set("currentPaymentChannel", currentPaymentChannels);
    }
    navigate({ search: params.toString() });
  }, [currentPaymentChannels, navigate]);

  // const handleOnChangeEmoney_source = (inputValue) => {
  //   if (inputValue === "wallet") {
  //     dispatch(checkWalletBalanceAction(Step1Info.id));
  //     if (!myWalletBalance?.balance && myWalletBalance?.balance != 0) {
  //       dispatch(getMyWalletBalanceAction());
  //     }
  //   }
  //   if (inputValue === "admin_verification") {
  //     dispatch(setStep3EmoneyFromWalletErrors([]));
  //     dispatch(getPaymentMethodsAction([]));
  //   }
  // };
  useEffect(() => {
    if (currentPaymentChannels === PAYMENT_CHANNELSS.WalletPayment) {
      dispatch(checkWalletBalanceAction(Step1Info.id));
      if (!myWalletBalance?.balance && myWalletBalance?.balance != 0) {
        dispatch(getMyWalletBalanceAction());
      }
    }
    if (currentPaymentChannels === PAYMENT_CHANNELSS.PaymentVerification) {
      dispatch(setStep3EmoneyFromWalletErrors([]));
      dispatch(getPaymentMethodsAction([]));
    }
  }, [currentPaymentChannels]);

  const onSubmitSuccessFuly = () => {
    let message = "Online payment method selected.";

    if (currentPaymentChannels === PAYMENT_CHANNELSS.WalletPayment) {
      message = "Wallet request has been sent successfully";
    }
    if (currentPaymentChannels === PAYMENT_CHANNELSS.PaymentVerification) {
      message =
        "Request has been sent successfully, waiting for admin approval";
    }

    Swal.fire({
      title: "Good!",
      text: message,
      icon: "success",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        if (currentPaymentChannels === PAYMENT_CHANNELSS.PaymentVerification) {
          navigate("/partners-list");
        } else {
          navigate(0);
        }
      }
    });
  };

  const handleSubmit = (values) => {
    const formData = new FormData();
    formData.append("client_id", Step1Info.id);
    formData.append("emoney_source", currentPaymentChannels);

    if (currentPaymentChannels === PAYMENT_CHANNELSS.WalletPayment) {
      if (!(EmoneyValidation?.length > 0)) {
        dispatch(
          saveStepData(formData, 3, true, () => {
            navigate(0);
          })
        );
      }
      dispatch(getCurrentPartnerStepInfoAction(Step1Info.id, () => {}));
    } else if (values.emoney_source === PAYMENT_CHANNELSS.PaymentVerification) {
      formData.append(
        "admin_verification[payment_method]",
        values.payment_method
      );
      formData.append(
        "admin_verification[payment_value]",
        values.payment_value
      );
      if (!(values.payment_trans_number == "")) {
        formData.append(
          "admin_verification[payment_trans_number]",
          values.payment_trans_number
        );
      }
      formData.append("admin_verification[payment_date]", values.payment_date); // format to YYYY-MM-DD
      formData.append("admin_verification[document]", values.document);
      if (!(values.payment_note.replace(/\s+/g, "").length === 0)) {
        formData.append(
          "admin_verification[payment_note]",
          values.payment_note
        );
      }

      dispatch(saveStepData(formData, 3, true, () => {}));
      dispatch(
        getCurrentPartnerStepInfoAction(
          Step1Info.id,
          () => {},
          () => {
            Navigate("/partners-list");
          }
        )
      );
    } else if (
      values.emoney_source === PAYMENT_CHANNELSS.OnlinePayment ||
      values.emoney_source === PAYMENT_CHANNELSS.OnlinePaymentInstallment
    ) {
      dispatch(saveStepData(formData, 3, true, () => {}));
      dispatch(getCurrentPartnerStepInfoAction(Step1Info.id, () => {}));
    }
    setRequestSent(true);
    onSubmitSuccessFuly(values.emoney_source);
  };

  return (
    <>
      <HeaderStep
        first_name={Step1Info?.first_name}
        second_name={Step1Info?.second_name}
        last_name={Step1Info?.last_name}
        stepName={"Verify e money"}
        stepNumber={"3"}
      />
      <div className="card-body">
        {message ||
          (Step1Info && (
            <>
              {Step1Info?.is_payment_verification_rejected ? (
                <div className="alert alert-danger tw-flex tw-gap-4">
                  <h1 className="message !tw-mb-0">
                    Payment Request is rejected by Admin
                  </h1>
                  {Step1Info?.rejection_note && (
                    <h3 className="!tw-mb-0">
                      Reason {Step1Info?.rejection_note}
                    </h3>
                  )}
                </div>
              ) : Step1Info?.is_pending_for_admin_verification ? (
                <div className="alert alert-warning">
                  <h1 className="message !tw-mb-0">
                    Waiting For Admin Verification
                  </h1>
                </div>
              ) : null}
            </>
          ))}
        {requestSent === false &&
          !Step1Info?.is_pending_for_admin_verification && (
            <>
              <Formik
                initialValues={stepOneInitialData}
                validationSchema={StepOneSchema}
                enableReinitialize // To reinitialize stepOneInitialData >> if exist
                onSubmit={handleSubmit}
              >
                {({ errors, touched, values, setFieldValue }) => (
                  <Form className="flex">
                    <div className="tw-w-full tw-grid">
                      <h2 className="tw-mx-auto tw-text-[17px] tw-text-primary !tw-font-semibold">
                        Select Money Source
                      </h2>
                    </div>
                    {/* Radio Buttons for Money Source */}
                    <div className="tw-grid tw-justify-center tw-grid-cols-1 lg:tw-grid-cols-2 xl:tw-grid-cols-4 tw-gap-4">
                      {paymentChannels?.map((paymentType) => (
                        <div
                          onClick={() => {
                            setCurrentPaymentChannels(paymentType.id);
                            setFieldValue("emoney_source", paymentType.id);
                          }}
                          className={`tw-bg-[#9e9e9e] tw-mx-auto tw-w-60 tw-cursor-pointer tw-text-center tw-text-[14px] md:tw-text-[15px] tw-py-2 tw-rounded-xl tw-text-white hover:tw-bg-[#a7a5a5] ${
                            paymentType.id === +currentPaymentChannels
                              ? "!tw-bg-primary"
                              : ""
                          }`}
                        >
                          {paymentType.name}
                        </div>
                      ))}

                      {currentPaymentChannels ===
                        PAYMENT_CHANNELSS.WalletPayment &&
                        !getWalletBalanceLoading && (
                          <p className="tw-pt-4 tw-font-medium tw-text-sm">
                            Registeration Wallet: {myWalletBalance?.balance} E.M
                          </p>
                        )}
                    </div>
                    <ErrorMessage
                      name="emoney_source"
                      component="div"
                      className="invalid-feedback tw-text-center"
                    />

                    {/* Conditionally Rendered Fields //admin_verification */}
                    <div className="row">
                      {currentPaymentChannels ===
                        PAYMENT_CHANNELSS.PaymentVerification && (
                        <>
                          <div className="col-md-6 mb-3">
                            <label
                              className="form-label required-label"
                              htmlFor="payment_method"
                            >
                              Payment Method
                            </label>
                            <Field
                              as="select"
                              name="payment_method"
                              className={`custom-control custom-select form-control ${
                                touched.payment_method
                                  ? errors.payment_method
                                    ? "custom-invalid-input"
                                    : ""
                                  : ""
                              }`}
                            >
                              <option value="">Select</option>
                              {paymentMethods?.length > 0 &&
                                paymentMethods.map((pm, pmIndex) => (
                                  <option key={pm.id} value={pm.id}>
                                    {pm[`method_name_${lang}`]}
                                  </option>
                                ))}
                            </Field>
                            <ErrorMessage
                              name="payment_method"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>

                          <div className="col-md-6 mb-3">
                            <label
                              className="form-label required-label"
                              htmlFor="payment_value"
                            >
                              Payment Value (EGP)
                            </label>
                            <Field
                              type="text"
                              value={values?.payment_value}
                              onChange={(e) => {
                                const { name, value } = e?.target;
                                if (/^\d{0,5}$/.test(value)) {
                                  setFieldValue(name, value);
                                }
                              }}
                              name="payment_value"
                              className={`form-control hidden-controls-number ${
                                touched.payment_value
                                  ? errors.payment_value
                                    ? "custom-invalid-input"
                                    : ""
                                  : ""
                              }`}
                            />
                            <ErrorMessage
                              name="payment_value"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>

                          <div className="col-md-6 mb-3 d-flex flex-column">
                            <label
                              className="form-label required-label mr-auto"
                              htmlFor="payment_date"
                            >
                              Payment Actual Date
                            </label>

                            <Flatpickr
                              value={values.payment_date}
                              onChange={([date]) => {
                                if (date != null) {
                                  const formattedDate = format(
                                    date,
                                    "yyyy-MM-dd"
                                  );
                                  setFieldValue("payment_date", formattedDate);
                                } else {
                                  setFieldValue("payment_date", "");
                                }
                              }}
                              onKeyDown={(e) => e.preventDefault()} // Disable keyboard input
                              onFocus={(e) => e.target.blur()} // Disable focus
                              dateFormat="yyyy-MM-dd"
                              options={{ maxDate: new Date() }}
                              className={`form-control ${
                                touched.payment_method
                                  ? errors.payment_date
                                    ? "custom-invalid-input"
                                    : ""
                                  : ""
                              }`}
                            />
                            <ErrorMessage
                              name="payment_date"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>

                          <div className="col-md-6 mb-3">
                            <label
                              className="form-label"
                              htmlFor="payment_trans_number"
                            >
                              Payment Transaction Number (Optional)
                            </label>
                            <Field
                              type="number"
                              name="payment_trans_number"
                              className="form-control"
                            />
                            <ErrorMessage
                              name="payment_trans_number"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>

                          <div className="col-md-6 mb-3">
                            <label
                              className="form-label required-label"
                              htmlFor="document"
                            >
                              receipt image
                            </label>
                            <div className="">
                              <input
                                type="file"
                                name="document"
                                className={`form-control ${
                                  touched.document
                                    ? errors.document
                                      ? "custom-invalid-input"
                                      : ""
                                    : ""
                                }`}
                                onChange={(event) => {
                                  const file = event.target.files[0];
                                  setFieldValue("document", file);
                                }}
                                accept=".pdf, .png, .jpg, .jpeg"
                              />
                            </div>

                            <ErrorMessage
                              name="document"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                          {/*  payment_note */}
                          <div className="col-md-6 mb-3">
                            <label
                              className="form-label"
                              htmlFor="payment_note"
                            >
                              payment note
                            </label>
                            <textarea
                              type="text"
                              name="payment_note"
                              className="form-control"
                              rows="4"
                              value={values.payment_note}
                              onChange={(e) => {
                                setFieldValue("payment_note", e.target.value);
                              }}
                            />
                            <ErrorMessage
                              name="payment_note"
                              component="div"
                              className="invalid-feedback"
                            />
                          </div>
                        </>
                      )}
                      <button
                        type="submit"
                        className="btn btn-primary ms-auto mt-5 !tw-w-[100px]"
                      >
                        {isLoading ? (
                          <RowLoader paddingStyle="tw-py-0" />
                        ) : (
                          "Submit"
                        )}
                      </button>
                    </div>
                    <ErrorMessage
                      name="apiError"
                      component="div"
                      className="invalid-feedback"
                    />
                  </Form>
                )}
              </Formik>
            </>
          )}
      </div>
    </>
  );
};

export default PartnerStepThree;
